//pages/services/userService.js
import { doc, setDoc, getDoc, serverTimestamp } from 'firebase/firestore';

import { db } from '../../config/firebase';

/**
 * Guarda o verifica los datos del usuario en Firestore
 * @param {Object} user - Usuario de Firebase Auth
 * @param {string} authProvider - Proveedor de autenticación (google, email, etc)
 */
export const saveUserData = async (user, authProvider) => {
  try {
    const userRef = doc(db, 'users', user.uid);
    const userSnap = await getDoc(userRef);

    // Si el usuario ya existe, no sobrescribir
    if (userSnap.exists()) {
      console.log('Usuario ya existe en la base de datos');
      return { exists: true, data: userSnap.data() };
    }

    // Si es nuevo, crear el documento
    const displayName = user.displayName || user.email.split('@')[0];
    const userData = {
      uid: user.uid,
      nom: { nom: displayName, apellP: '', apellM: '' },
      authProvider,
      email: user.email,
      auth: true,
      rol: {},
      addRec: serverTimestamp(),
      Lic: { Nv: 1, vg: serverTimestamp() }
    };

    await setDoc(userRef, userData);
    console.log('Nuevo usuario registrado en Firestore');
    return { exists: false, data: userData };
  } catch (err) {
    console.error('Error al guardar datos del usuario:', err);
    throw new Error('Error al guardar datos del usuario');
  }
};